var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6157 30C32.235 30 31.1157 31.1193 31.1157 32.5C31.1157 33.8807 32.235 35 33.6157 35C34.9964 35 36.1157 33.8807 36.1157 32.5C36.1157 31.1193 34.9964 30 33.6157 30ZM28.1157 32.5C28.1157 29.4624 30.5782 27 33.6157 27C36.6533 27 39.1157 29.4624 39.1157 32.5C39.1157 35.5376 36.6533 38 33.6157 38C30.5782 38 28.1157 35.5376 28.1157 32.5Z",
    fill: "#A3B2BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8051 22.6893C24.474 20.0204 28.4678 19 33.6157 19H41.6157C42.4441 19 43.1157 19.6716 43.1157 20.5C43.1157 21.3284 42.4441 22 41.6157 22H33.6157C28.7637 22 25.7574 22.9796 23.9264 24.8107C22.0953 26.6417 21.1157 29.6479 21.1157 34.5V46.5C21.1157 51.3521 22.0953 54.3583 23.9264 56.1893C25.7574 58.0204 28.7637 59 33.6157 59H45.6157C50.4678 59 53.474 58.0204 55.3051 56.1893C57.1361 54.3583 58.1157 51.3521 58.1157 46.5V36.5C58.1157 35.6716 58.7873 35 59.6157 35C60.4441 35 61.1157 35.6716 61.1157 36.5V46.5C61.1157 51.6479 60.0953 55.6417 57.4264 58.3107C54.7574 60.9796 50.7637 62 45.6157 62H33.6157C28.4678 62 24.474 60.9796 21.8051 58.3107C19.1361 55.6417 18.1157 51.6479 18.1157 46.5V34.5C18.1157 29.3521 19.1361 25.3583 21.8051 22.6893Z",
    fill: "#A3B2BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1157 26.5C46.1157 25.6716 46.7873 25 47.6157 25H58.6157C59.4441 25 60.1157 25.6716 60.1157 26.5C60.1157 27.3284 59.4441 28 58.6157 28H47.6157C46.7873 28 46.1157 27.3284 46.1157 26.5Z",
    fill: "#A3B2BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6157 19C53.4441 19 54.1157 19.6716 54.1157 20.5V31.5C54.1157 32.3284 53.4441 33 52.6157 33C51.7873 33 51.1157 32.3284 51.1157 31.5V20.5C51.1157 19.6716 51.7873 19 52.6157 19Z",
    fill: "#A3B2BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4692 42.6631C54.4872 41.8012 52.8245 41.8012 51.8424 42.6631L43.6542 49.8433C41.5657 51.6759 38.2682 51.6762 36.1798 49.8433L36.1672 49.8322L35.5247 49.2551C34.642 48.4853 33.1336 48.3908 32.1183 49.0868L22.415 55.7438C21.7381 56.2081 20.821 56.0239 20.3665 55.3322C19.912 54.6406 20.0923 53.7034 20.7692 53.2391L30.473 46.5818C32.5655 45.1474 35.5411 45.2921 37.4542 46.9716L37.4667 46.9826L38.1091 47.5596C39.0919 48.4167 40.7502 48.4151 41.7304 47.5548L49.9186 40.3746C52.0071 38.542 55.3046 38.5416 57.393 40.3746L60.6013 43.1903C61.2198 43.7331 61.2906 44.6855 60.7593 45.3174C60.2281 45.9494 59.2961 46.0217 58.6776 45.4789L55.4692 42.6631Z",
    fill: "#A3B2BD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.ad2bb98f10233945db6852b5a823dd51.svg";
export { ForwardRef as ReactComponent };